import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import InlineTextInput from '@/components/ui/inline-text-input';

const TaskDialog = ({
  titleValue,
  setTitleValue,
  descriptionValue,
  setDescriptionValue,
  onClickCta,
  ctaText,
  onOpen,
  onClose,
  dialogIsOpen,
  children,
}: {
  titleValue: string;
  setTitleValue: (titleValue: string) => void;
  descriptionValue: string;
  setDescriptionValue: (descriptionValue: string) => void;
  onClickCta: ({
    titleValue,
    descriptionValue,
  }: {
    titleValue: string;
    descriptionValue: string;
  }) => void;
  ctaText: string;
  onOpen: () => void;
  onClose: () => void;
  dialogIsOpen: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <Dialog open={dialogIsOpen} modal={false}>
      <DialogTrigger asChild onClick={onOpen}>
        {children}
      </DialogTrigger>
      <DialogContent
        className="sm:max-w-[425px]"
        onClickClose={onClose}
        onPointerDownOutside={onClose}
      >
        <DialogHeader>
          <DialogTitle>Task</DialogTitle>
          <DialogDescription>Add a new task to the deal.</DialogDescription>
        </DialogHeader>
        <InlineTextInput
          className="rounded text-xs"
          placeholder="Add Title"
          value={titleValue}
          onChange={(e) => setTitleValue(e.target.value)}
        />
        <InlineTextInput
          className="rounded text-xs"
          placeholder="Add Description"
          value={descriptionValue}
          onChange={(e) => setDescriptionValue(e.target.value)}
        />
        <DialogFooter>
          <Button
            type="submit"
            onClick={() => {
              onClickCta({
                titleValue,
                descriptionValue,
              });
            }}
          >
            {ctaText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TaskDialog;
